<template>
  <div class="mb-2 d-flex justify-content-center align-items-center">
    <slot name="left-content"></slot>
    <div class="mr-2 text-primary font-weight-bolder text-nowrap">
      <slot></slot>
    </div>
    <hr class="w-full" style="border-top: 2px solid #005CC4"/>
    <slot name="right-content"></slot>
  </div>
</template>
<script>
export default {
  name: 'AppFormSubTitle',
};
</script>



// WEBPACK FOOTER //
// src/components/app-form/form-sub-title.vue